import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

import {
  fetchGetComparisonAlbums,
  TGetComparisonAlbumsResponse,
} from '../../repositories/property-comparison/v1/get-comparison-albums';
import { TComparisonAlbums } from '../../types/redux/comparisonAlbums';

interface IDependencies {
  httpApi: IHttpApi;
  logger: ILogger;
}

export const DEFAULT_ALBUMS: TComparisonAlbums = {
  comparisonAlbums: [
    {
      title: 'Квартиры',
      subtitle: 'Нет объектов',
      propertyType: 'offer',
      images: [],
    },
    {
      title: 'ЖК',
      subtitle: 'Нет объектов',
      propertyType: 'newbuilding',
      images: [],
    },
  ],
};

export async function resolveComparisonAlbums({ httpApi, logger }: IDependencies): Promise<TComparisonAlbums> {
  try {
    const response: TGetComparisonAlbumsResponse = await fetchGetComparisonAlbums({ httpApi });

    if (response.statusCode !== 200) {
      logger.warning('[Degradation] Не удалось получить альбомы сравнения', { statusCode: response.statusCode });

      return DEFAULT_ALBUMS;
    }

    return response.response;
  } catch (error) {
    logger.warning('[Degradation] Не удалось получить альбомы сравнения', error);

    return DEFAULT_ALBUMS;
  }
}
